<template>
  <AppPage class="OrderDetail">
    <AppHeader
        title="ESTADO DEL PEDIDO"
        :left-action="onBack"
        right-icon="question-circle"
        :right-action="()=>$router.push('/help')"
    />
    <AppSection>
      <PaymentStatus :PaymentResult="order && order.paymentResult" />
      <div v-if="order && order.order">
        <template v-if="order.paymentResult && order.paymentResult.Ds_Response === '0000'">
          <div v-if="order.location && order.deliveryData" class="alert alert-info text-center">
            <p>Entregaremos tu pedido en 30 minutos <br> aproximadamente. Gracias!</p>
            <a :href="order.deliveryData.trackingLink" target="_blank" class="btn btn-info btn-lg btn-block">
              <i class="fa fa-map-marker-alt mr-2" />
              <small>VER SEGUIMIENTO DEL PEDIDO</small>
            </a>
            <!-- {{trackingLink}} -->
          </div>
          <div v-else class="alert alert-info text-center">
            <p>Tu pedido estará listo en 30 minutos <br> aproximadamente. Gracias!</p>
            <a href="https://goo.gl/maps/p8y4fhFdb1p" target="_blank" class="btn btn-info btn-lg btn-block">
              <i class="fa fa-map-marker-alt mr-2" />
              <small>VER EN GOOGLE MAPS</small>
            </a>
          </div>
        </template>
        <div class="card user-order OrderDetail__details mb-4">
          <div class="card-body user-order-detail">
            <div class="user-order-detail__details">
              <div class="row">
                <div class="col-8">
                  <small class="capitalize">{{orderDateFromNow}}</small>
                  <div class="capitalize">{{orderDate}}</div>
                  <small class="capitalize" v-if="order.location">{{order.location.address}}</small>
                </div>
                <div class="col-4 text-right">
                  <small class="text-muted">Total:</small>
                  {{order.total}}€
                </div>
              </div>
            </div>
          </div>
        </div>
        <OrderProduct
            :product="product"
            :editable="false"
            v-for="(product, index) in order.order" :key="index"
        />
      </div>
      <div v-else class="alert alert-danger text-center">
        <i class="fa fa-exclamation-triangle" />
        <br>
        NO SE ENCONTRÓ EL PEDIDO
      </div>
    </AppSection>
  </AppPage>
</template>
<script>
  import moment from 'moment'
  import { usersRef } from '../firebase'
  import PaymentStatus from '../components/Payment/PaymentStatus'
  import OrderProduct from '../components/Order/OrderProduct'

  export default {
    components: {PaymentStatus, OrderProduct},
    data() {
      return {
        order: null,
        trackingLink: null,
      }
    },
    computed: {
      products() {
        const order = this.order
        if (!order && !order.order) return []
        return order.order && Object.values(order.order || [])
      },
      orderDateFromNow() {
        const order = this.order
        return moment(order.date).fromNow()
      },
      orderDate() {
        const order = this.order
        return moment(order.date).format('dddd DD MMMM - HH:mm[h]')
      },
      total() {
        const order = this.order
        return order.total
      },
    },
    methods: {
      onBack() {
        this.$router.push('/')
      },
    },
    mounted() {
      const {userId, orderId} = this.$route.params
      usersRef
        .child(userId)
        .child('orders')
        .child(orderId)
        .on('value', snap => {
          this.order = snap.val()
        })

      this.$store.commit('isLoading', false)

      // si el resultado es ok (params.result === 'ok')
      // si la location !== false
      // hay que llamar a shargo para que nos de la info de entrega (link)
      // y mostrarlos en la página
      // si no tiene location hay que mostrar el telefono y tal con info
      // también de google maps para que pasen a recoger el pedido
      // si el resultado es ko (params.result === 'ko')
      // hay que dar la opción al cliente de que pueda volver a realizar el pago
      // y además hay que mostrar telefono y tal para que llame si eso
    },
  }
</script>




// WEBPACK FOOTER //
// src/views/OrderStatus.vue